
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref3f4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref3f4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eg320", function(module, exports) {

$parcel$export(module.exports, "isLocal", function () { return $d0683ef292cd6785$export$6dd1bbd39f571125; });
$parcel$export(module.exports, "adminUrl", function () { return $d0683ef292cd6785$export$d6b995f2aa87f3a0; });
$parcel$export(module.exports, "isDemo", function () { return $d0683ef292cd6785$export$7a7fb88e277126a7; });
$parcel$export(module.exports, "isDevEnv", function () { return $d0683ef292cd6785$export$8d028de9c8e0908; });
$parcel$export(module.exports, "apiUrl", function () { return $d0683ef292cd6785$export$e9ddf1da8d18d6f; });
$parcel$export(module.exports, "roles", function () { return $d0683ef292cd6785$export$8e77a375f9a5908e; });
$parcel$export(module.exports, "INVITE_CRUMBS", function () { return $d0683ef292cd6785$export$c305fd1afb53b526; });
$parcel$export(module.exports, "userRoles", function () { return $d0683ef292cd6785$export$b67b44fd968de711; });
$parcel$export(module.exports, "route", function () { return $d0683ef292cd6785$export$4cb887bfde2d34ca; });
$parcel$export(module.exports, "minimumPasswordLength", function () { return $d0683ef292cd6785$export$bc6cf55980135996; });
$parcel$export(module.exports, "supportedCountries", function () { return $d0683ef292cd6785$export$559d7c76276069b5; });
const $d0683ef292cd6785$export$6dd1bbd39f571125 = false;
let $d0683ef292cd6785$var$isDemoLocal = false;
let $d0683ef292cd6785$var$isDevLocal = false;
let $d0683ef292cd6785$var$remoteApiUrl = "https://api.ommej.se/";
let $d0683ef292cd6785$export$d6b995f2aa87f3a0 = "https://admin.ommej.se";
if (window.location.hostname.startsWith("dev-admin")) {
    $d0683ef292cd6785$var$remoteApiUrl = "https://dev-api.ommej.se/";
    $d0683ef292cd6785$export$d6b995f2aa87f3a0 = "https://dev-admin.ommej.se";
    $d0683ef292cd6785$var$isDevLocal = true;
} else if (window.location.hostname.startsWith("demo-admin")) {
    $d0683ef292cd6785$var$remoteApiUrl = "https://demo-api.ommej.se/";
    $d0683ef292cd6785$export$d6b995f2aa87f3a0 = "https://demo-admin.ommej.se";
    $d0683ef292cd6785$var$isDemoLocal = true;
}
if ($d0683ef292cd6785$export$6dd1bbd39f571125) $d0683ef292cd6785$export$d6b995f2aa87f3a0 = "http://localhost:9000";
const $d0683ef292cd6785$export$7a7fb88e277126a7 = $d0683ef292cd6785$var$isDemoLocal;
const $d0683ef292cd6785$export$8d028de9c8e0908 = $d0683ef292cd6785$var$isDevLocal;
const $d0683ef292cd6785$var$setDevApi = ()=>{
    return "http://localhost:8080/";
};
const $d0683ef292cd6785$export$e9ddf1da8d18d6f = $d0683ef292cd6785$export$6dd1bbd39f571125 ? $d0683ef292cd6785$var$setDevApi() : $d0683ef292cd6785$var$remoteApiUrl;
const $d0683ef292cd6785$export$8e77a375f9a5908e = {
    systemAdmin: "SYSTEM_ADMIN",
    administrator: "ADMINISTRATOR",
    user: "USER"
};
const $d0683ef292cd6785$export$c305fd1afb53b526 = {
    CREATE: "CREATE",
    GROUP: "GROUP",
    SINGLE: "SINGLE",
    INVITE: "INVITE",
    CREATED: "CREATED",
    SUCCESS: "SUCCESS"
};
const $d0683ef292cd6785$export$b67b44fd968de711 = {
    SYSTEM_ADMIN: "Systemadministrat\xf6r",
    ADMINISTRATOR: "Administrat\xf6r",
    USER: "Anv\xe4ndare"
};
const $d0683ef292cd6785$export$4cb887bfde2d34ca = {
    ROOT: "/",
    HOME: "/home",
    CASES: "/cases",
    CASES_ADD: "/cases/add",
    CASE: "/case",
    CASE_REPORT: "/case/report",
    ADMIN: "/admin",
    ADMIN_USERS: "/admin/users",
    ADMIN_USERS_ADD: "/admin/users/add",
    ADMIN_UNITS: "/admin/units",
    ADMIN_PROFILE: "/admin/profile",
    ARTICLES: "/articles",
    STATISTICS: "/statistics",
    STATISTICS_QUESTIONS: "/statistics/questions",
    STATISTICS_FORMS: "/statistics/forms",
    RESET_PASSWORD: "/resetpwd",
    LOGIN_PASSWORD: "/password"
};
const $d0683ef292cd6785$export$bc6cf55980135996 = 6;
const $d0683ef292cd6785$export$559d7c76276069b5 = {
    se: {
        localization: "Sverige",
        countryCode: "se",
        dialCode: "+46",
        validator: {
            sms: /^(?:\s*-*\s*\d){10}$/,
            email: /^\S+@\S+$/
        }
    }
};

});


var $eg320 = parcelRequire("eg320");
const $3a2c19ae02ed8566$var$trackUrl = "https://misc.ommej.se/umami/script.js";
const $3a2c19ae02ed8566$var$devId = "7c937f28-5be4-44a9-8330-a9428fcdb39c";
const $3a2c19ae02ed8566$var$demoId = "2a59228f-a830-4b7e-baa9-cf205c2025f5";
const $3a2c19ae02ed8566$var$prodId = "d7c64150-b263-493f-86bc-d61c86188404";
const $3a2c19ae02ed8566$var$createScriptTag = (environmentId)=>{
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.setAttribute("defer", "");
    script.setAttribute("async", "");
    script.dataset.websiteId = environmentId;
    script.dataset.doNotTrack = "true";
    script.setAttribute("src", $3a2c19ae02ed8566$var$trackUrl);
    if (head) head.appendChild(script);
};
const $3a2c19ae02ed8566$var$loadTrackerScript = ()=>{
    if (0, $eg320.isLocal) return;
    if (0, $eg320.isDevEnv) $3a2c19ae02ed8566$var$createScriptTag($3a2c19ae02ed8566$var$devId);
    else if (0, $eg320.isDemo) $3a2c19ae02ed8566$var$createScriptTag($3a2c19ae02ed8566$var$demoId);
    else $3a2c19ae02ed8566$var$createScriptTag($3a2c19ae02ed8566$var$prodId);
};
$3a2c19ae02ed8566$var$loadTrackerScript();


//# sourceMappingURL=index.a7c8d5fb.js.map
